import { render } from "./SalesSkeleton.vue?vue&type=template&id=47512412&scoped=true"
import script from "./SalesSkeleton.vue?vue&type=script&lang=js"
export * from "./SalesSkeleton.vue?vue&type=script&lang=js"

import "./SalesSkeleton.vue?vue&type=style&index=0&id=47512412&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47512412"]])

export default __exports__